import { Grid } from '@mui/material';
import { InputOnlyField, Text } from '@ngt/forms';
import { FC } from 'react';

const columnMapping = {
    xs: 12,
    sm: 6,
    md: 6
}

const SocialLinksFields: FC = () => {
    return (
        <Grid item xs={12} container spacing={2}>
            <Grid
                item
                {...columnMapping}
            >
                <InputOnlyField
                    label="LinkedIn Link (If Applicable)"
                    propertyPath="linkedInLink"
                    component={Text}
                    variant="standard"
                    margin="normal"
                />
            </Grid>
            <Grid
                item
                {...columnMapping}
            >
                <InputOnlyField
                    label="X Link (If Applicable)"
                    propertyPath="twitterLink"
                    component={Text}
                    variant="standard"
                    margin="normal"
                />
            </Grid>
        </Grid>
    );
}

export default SocialLinksFields;
